<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <div class="container1400">
        <v-skeleton-loader
          v-if="loading"
          type="article"
          class="mt-10"
        ></v-skeleton-loader>
        <v-container fluid v-if="!loading">
          <div class="mt-5">
            <v-alert dense outlined type="error" v-if="error">
              <ul>
                <li v-for="item in error" :key="item.msg">
                  {{ $t(item.msg) }}
                </li>
              </ul>
            </v-alert>
            <div v-if="list">
              <div v-if="list.property_id" class="pt-5">
                <v-card height="100%" elevation="0" class="pa-5">
                  <v-row>
                    <v-col cols="12" md="4" class="pt-0 pb-0">
                      <v-sheet
                        color="blue"
                        height="240"
                        v-if="!list.property_id.pictures"
                      >
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center"
                        >
                          <div class="display-3">NO Images</div>
                        </v-row>
                      </v-sheet>
                      <v-carousel
                        hide-delimiters
                        class="mb-5 pr-md-9"
                        height="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in list.property_id.pictures"
                          :key="i"
                          :src="
                            $store.state.baseUrl +
                              'listing/thumb320x240-' +
                              item.file_name
                          "
                        >
                        </v-carousel-item>
                      </v-carousel>
                      <h1 class="text-h6 mb-2">
                        {{ $t("TripTo") }} {{ list.property_id.name }},
                        {{ list.property_id.location }}
                      </h1>
                      <div class="subtitle-2 mb-2">
                        {{ $t("TripStatus") }} : {{ $t(list.booking_status) }}
                      </div>
                      <div class="subtitle-2 mb-2">
                        {{ $t("Tripid") }} : {{ list._id }}
                      </div>
                    </v-col>
                    <v-col md="8" cols="12" class="pt-0 pb-0">
                      <v-alert dense outlined type="error" v-if="error">
                        <ul>
                          <li v-for="item in error" :key="item.msg">
                            {{ $t(item.msg) }}
                          </li>
                        </ul>
                      </v-alert>
                      <v-form
                        ref="form"
                        v-model="valid"
                        @submit.prevent="next"
                        lazy-validation
                        class="pa-5 pt-0"
                      >
                        <h1 class="text-h6">
                          {{ $t("ChangeBookingReq") }}
                        </h1>
                        <v-row>
                          <v-col cols="4">
                            <div class="overline grey--text">
                              {{ $t("CCheckin") }}
                            </div>
                            <div class="subtitle-2">
                              {{
                                format(
                                  new Date(
                                    list.booking_details.dates[0] + "T00:00"
                                  ),
                                  "eee, do MMM, yyyy"
                                )
                              }}
                              <span class="grey--text">
                                - {{ list.booking_details.check_in_time }}</span
                              >
                            </div>
                          </v-col>
                          <v-col cols="4">
                            <div class="overline grey--text">
                              {{ $t("CCheckout") }}
                            </div>
                            <div class="subtitle-2">
                              {{
                                format(
                                  new Date(
                                    list.booking_details.dates[1] + "T00:00"
                                  ),
                                  "eee, do MMM, yyyy"
                                )
                              }}
                              <span class="grey--text">
                                -
                                {{ list.booking_details.check_out_time }}</span
                              >
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" class="pb-0">
                            <div class="overline grey--text">
                              {{ $t("CcCheckin") }}
                            </div>
                            <v-date-picker
                              v-model="data.check_in_date"
                              color="light-blue"
                            ></v-date-picker>
                            <v-select
                              dense
                              v-model="data.check_in_time"
                              :items="list.property_id.check_in_times"
                              :rules="reqRules"
                              :label="$t('Time')"
                              outlined
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6" class="pb-0">
                            <div class="overline grey--text">
                              {{ $t("CcCheckout") }}
                            </div>
                            <v-date-picker
                              v-model="data.check_out_date"
                              color="light-blue"
                            ></v-date-picker>
                            <v-select
                              dense
                              v-model="data.check_out_time"
                              :items="list.property_id.check_out_times"
                              :rules="reqRules"
                              :label="$t('Time')"
                              outlined
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-radio-group
                          v-model="data.urgency"
                          class="mt-0"
                          :rules="reqRules"
                        >
                          <v-radio
                            v-for="(item, i) in urgency"
                            :key="i"
                            :value="item"
                            :rules="reqRules"
                            v-bind:label="$t(item)"
                          >
                          </v-radio>
                        </v-radio-group>
                        <v-textarea
                          dense
                          outlined
                          v-model="data.reason"
                          :rules="reqRules"
                          :label="$t('ChangeBookingReason')"
                          rows="3"
                        ></v-textarea>
                        <div class="subtitle-2 red--text mb-2">
                          {{ $t("CBmsg11") }}
                        </div>
                        <div class="subtitle-2">
                          {{ $t("CBmsg5") }}
                        </div>
                        <v-row>
                          <v-col cols="12">
                            <v-btn color="red" dark @click="changeBooking">
                              {{ $t("Yes") }}
                            </v-btn>
                            <v-btn
                              color="light-blue"
                              text
                              :to="{
                                name: 'ViewBooking',
                                params: { id: parm }
                              }"
                            >
                              {{ $t("CBmsg4") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import BookingService from "@/services/BookingService";
import defaultJson from "@/assets/default.json";
import { format } from "date-fns";

export default {
  name: "ChangeBookingRequest",
  mixins: [timeoutMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    WaitDialogComponent
  },
  data() {
    return {
      format,
      valid: null,
      waitDialog: false,
      loading: true,
      list: [],
      data: {},
      parm: this.$route.params.id,
      error: null,
      dialog: false,
      urgency: defaultJson.urgencyPriority,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  computed: {
    computedClass() {
      let className = "";
      if (this.list.payment_status == "Approved") {
        className = "light-green white--text";
      } else if (this.list.payment_status == "Pending") {
        className = "red darken-1 white--text";
      }
      return className;
    }
  },
  created: function() {
    BookingService.viewBooking({
      id: this.parm
    })
      .then(async result => {
        const resultList = await result.data.list;
        let {
          property_id: { pictures }
        } = resultList;
        pictures && pictures.sort((a, b) => a.order - b.order);
        this.list = { ...resultList, pictures };
        this.data.booking_id = this.list._id;
        this.data.property_user_id = this.list.property_user_id;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async changeBooking() {
      await this.$refs.form.validate();
      if (this.valid) {
        BookingService.changeBooking(this.data)
          .then(() => {
            this.$router.push({
              name: "ViewBooking",
              params: { id: this.parm }
            });
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style></style>
